/**
 * This is a callback method which is responsible for making fine adjustments to the generic MySsFilterParams
 * builded by 'adaptQueryParams' method.
 * @param {IOrderFilterParams} mySsFilterParamsResult
 * @returns {IOrderFilterParamsDTO} mySsFilterParamsResult
 */
export function prepareOrderFilterQueryParams(
  mySsFilterParamsResult: IOrderFilterParams,
): IOrderFilterParamsDTO {
  const result: IOrderFilterParamsDTO = {
    ...omit(mySsFilterParamsResult, ['orderStatus']),
    filteredField:
      ORDER_FILTERED_FIELD_OPTIONS_ENUM[mySsFilterParamsResult.filteredField],
    status: ORDER_STATUS_ENUM[mySsFilterParamsResult.orderStatus],
    productType: ORDER_PRODUCT_TYPE_ENUM[mySsFilterParamsResult.productType],
  };

  const keys: (keyof IOrderFilterParamsDTO)[] = Object.keys(
    result,
  ) as (keyof IOrderFilterParamsDTO)[];
  return removeEmptyFields<IOrderFilterParamsDTO>(...keys)(result);
}
